<template>
    <div class="qksm qksm14">
        <h4>十四、其他重要事项情况说明</h4>
        <div class="nogap">
            <p>
                国有资产占用情况。截至2020年12月31日，{{$store.state.divData.divname}}共有车辆<reason type="integer" classname="qksm integer" name="共有车辆" v-model:value="car.共有车辆"></reason>辆，
                其中：副部（省）级及以上领导用车<reason type="integer" classname="qksm integer" name="领导用车" v-model:value="car.领导用车"></reason>辆、
                主要领导干部用车<reason type="integer" classname="qksm integer" name="主要领导用车" v-model:value="car.主要领导用车"></reason>辆、
                机要通信用车<reason type="integer" classname="qksm integer" name="机要通信用车" v-model:value="car.机要通信用车"></reason>辆、
                应急保障用车<reason type="integer" classname="qksm integer" name="应急保障用车" v-model:value="car.应急保障用车"></reason>辆、
                执法执勤用车<reason type="integer" classname="qksm integer" name="执法执勤用车" v-model:value="car.执法执勤用车"></reason>辆、
                特种专业技术用车<reason type="integer" classname="qksm integer" name="特种专业用车" v-model:value="car.特种专业用车"></reason>辆、
                离退休干部用车<reason type="integer" classname="qksm integer" name="离退休干部用车" v-model:value="car.离退休干部用车"></reason>辆、
                其他用车<reason type="integer" classname="qksm integer" name="其他用车" v-model:value="car.其他用车"></reason>辆；
                单价50万元以上通用设备<reason type="integer" classname="qksm integer" name="通用设备" v-model:value="qksm['通用设备']"></reason>台，
                单价100万元以上专用设备<reason type="integer" classname="qksm integer" name="专用设备" v-model:value="qksm['专用设备']"></reason>台（套）。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm14",
        data() {
            var arr = ["共有车辆", "领导用车", "主要领导用车", "机要通信用车", "应急保障用车", "执法执勤用车", "特种专业用车", "离退休干部用车", "其他用车"]
            var car = [];
            for (var i = 0; i < arr.length; i++) {
                car[arr[i]] = this.$store.state.divData.qksm[arr[i]]
            }
            return {
                qksm: this.$store.state.divData.qksm,
                car:car,
                isPdf: this.$parent.isPdf
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                var arr = Object.values(this.car)
                var sum = 0;
                for (var i = 1; i < arr.length; i++) {
                    sum = sum + this.num(arr[i])
                }
                if (this.num(arr[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm14", "请检查本页《十四、其他重要事项情况说明》，各项车辆使用情况总和应该等于部门共有车辆总数。");
                } else {
                    this.remove("qksm14")
                }
            }
        }, components: {
            reason,
        },
    };
</script>
